import Vue from "vue"
import vueResource from "vue-resource"
import { Loading } from 'element-ui';
Vue.use(vueResource)

const baseUrl = process.env.API_ROOT+'api/';
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push((request, next) => {
	//   help.showLoading = true;    
	//you can do something in interceptors
	// request.headers.set('token':sessionStorage.getItem('token')||'');
	var TOKEN = sessionStorage.getItem('token') || '';
	request.headers.set('token', TOKEN);
	//配置请求头
	next((response) => {
		if (!response) {
			//do something when response
		}
		return response;
	});
});

export function post(url, params,load=true) {
	return new Promise((resolve, reject) => {
		var user_token = sessionStorage.getItem('token') || '';
		// params['user_token']=user_token;
		var loadingInstance=false;
		if (load) {
			var target='document.body';
			if (params.target) {
				target=params.target
			}
			loadingInstance = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				target:target,
				background: 'rgba(0, 0, 0, 0.7)'
			});
		}
		Vue.http.post(baseUrl + url, params, ).then(res => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 888){
					sessionStorage.removeItem('token');
					this.$router.push('/login');
				} else {
					this.$message.error(res.body.message);
				}
			} else if(res.status == 0) {
				sessionStorage.removeItem('token');
				this.$router.push('/login');
			} else {
				this.$message.error('请检查网络');
			}
			if (load&&loadingInstance) {
				loadingInstance.close();
			}
		}).catch((err) => {
			if (load&&loadingInstance) {
		        loadingInstance.close();
			}
			console.log(err)
			reject(err);
		});
	});
}
export function get(url) {
	return new Promise((resolve, reject) => {
		Vue.http.get(baseUrl + url, ) .then((res) => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 888){
					sessionStorage.removeItem('token');
					this.$router.push('/login');
				} else {
					this.$message.error(res.body.message);
				}
			} else {
				this.$message.error('请检查网络');
			}
		}) .catch((err) => {
			reject(err);
		});
	});
}



//////////////////
// WEBPACK FOOTER
// ./store/vue_resource.js
// module id = null
// module chunks = 